








































































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import DataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import { Company } from "../../models";
import Companiesmixin from "../../mixins/http/CompaniesMixin";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";

@Component({ components: { Page, DataTable, Paginator } })
export default class CompanyList extends Mixins(Companiesmixin) {
  static readonly getCompaniesTag = "get_companies_tag";
  @RegisterHttp(CompanyList.getCompaniesTag) getCompaniesRequest: RequestData;
  private items: Company[] = [];

  get columns() {
    let columns = [];

    columns.push({ name: "logo", label: "" });
    columns.push({ name: "name", label: "Name" });
    if (this.$mq !== "sm" && this.$mq !== "md" && this.$mq !== "lg") {
      // columns.push({ name: "users_count", label: "Total users" });
      columns.push({ name: "countries", label: "Countries" });
      columns.push({ name: "currency", label: "Currency" });
    }
    columns.push({ name: "contacts", label: "Contacts" });
    return columns;
  }

  mounted() {
    this.loadCompanies();
  }

  goToCompany(item) {
    this.$router.push({
      name: "company_show_general_data",
      params: { id: item.id },
    });
  }

  loadCompanies(page = 1) {
    this.getCompanies({ page: page }, CompanyList.getCompaniesTag).then(
      (resp) => {
        this.items = resp;
      },
      (err) => {}
    );
  }

  onPageChange(page) {
    this.loadCompanies(page);
  }

  get loading() {
    return this.getCompaniesRequest?.loading;
  }

  get meta() {
    return this.getCompaniesRequest?.meta;
  }
}
